var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$route.name === 'home')?_c('div',[_c('Home')],1):_c('div',[_c('Navbar'),_c('p',{staticStyle:{"margin":"10px"}},[_vm._v(_vm._s(this.$route.path))]),_c('div',{staticClass:"container mt-5"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }